<template>
  <div class="tabs_content r-tabs-panel r-tabs-state-active" id="tab-2" style="display: block;">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"
    />
    <section>

      <div class="status">
        <h2>Kanály</h2>
        <a
            v-if="isEditable"
            :title="$gettext('Přidat kanálů')"
            :class="['add', 'add_expand', { open: addChannelOpen }]"
            @click.prevent="toggleAddChannel()"
            v-translate>Přidat kanál</a>
      </div>
      <div :class="['filter', 'expand_content', { open: addChannelOpen }]">
        <div class="left">
          <multiselect-searchbox
              :disabled="!isEditable"
              :searchFunction="searchChannels"
              v-model="addChannelIds"
          ><translate>Kanál</translate>
          </multiselect-searchbox>
        </div>
        <div class="field_right">
          <div class="field">
            <input
                type="submit"
                class="btn"
                :value="'Přidat' | translate"
                @click.prevent.stop="addChannels"
            />
          </div>
        </div>
      </div>

      <div class="table_overflow" id="contentBox" data-table-id="advertising-providers-channels">
        <table class="vypis vypis_detail">
        <thead class="no_sortable">
        <tr>
          <sorting-table-title
              v-for="title in tableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit"></th>
        </tr>
        </thead>
        <advertising-provider-channel-group-detail-channel-row
            v-for="channel in entity.channels"
            :entity="channel"
            :key="channel.id_channel"
            :is-editable="$_updateActionAllowed"
            :ref="'channel-group-row-ref-'+channel.id_channel"
            @updateChannel="updateChannel"
            @deleteChannel="deleteChannel"
        />
        <tr v-if="entity.channels.length === 0">
          <td colspan="6">{{ $gettext('Nebyly nalezeny žádné kanály.') }}</td>
        </tr>
      </table>
      </div>
    </section>

  </div>
</template>

<script>
import AdvertisingProviderChannelGroupDetailChannelRow from "./ChannelRow.vue"
import Popup from "@/components/common/Popup"
import message from "../../../mixins/message";
import popup from "@/components/mixins/popup"
import SortingTableTitle from "../../../common/SortingTableTitle.vue";
import { sortByKey } from "../../../../utils/helpers";

export default {
  name: 'AdvertisingProviderChannelGroupDetailChannelsList',
  components: { SortingTableTitle, AdvertisingProviderChannelGroupDetailChannelRow, Popup },
  mixins: [message, popup],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  created(AdvertisingProviderChannelGroupService, ChannelService) {
    this.entityService = AdvertisingProviderChannelGroupService
    this.channelService = ChannelService
  },
  data() {
    return {
      entityName: 'advertisingProviderChannelGroup',
      updateFields: [
        'code',
        'name',
        'module_type',
        'authentication_data',
      ],
      formFields: {
        search: null,
      },
      addChannelOpen: false,
      addChannelIds: [],
      sort: null,
    }
  },
  computed: {
    tableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'name'},
        {key: 2, name: this.$gettext('ID'), column: 'id_channel'},
        {key: 3, name: this.$gettext('Přemapované ID'), column: 'id_mapped'},
        {key: 4, name: this.$gettext('Přidal'), column: 'user_created'},
        {key: 5, name: this.$gettext('Přidáno'), column: 'timestamp_created'},
      ];
    },
  },
  methods: {
    updateChannel(data) {
      let params = {
        id_channel: data.id_channel,
        id_mapped: data.id_mapped,
      }
      this.entityService.updateChannel(this.entity.id, params)
          .then(() => {
            this.$refs['channel-group-row-ref-' + data.id_channel][0].isOpen = false
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    },
    executePopupAction(value) {
      if (value === true) {
        if (this.getPopupAction === 'delete') {
          this.$emit('deleteChannelGroup');
        }
        if (this.getPopupAction === 'delete-channel') {
          this.deleteChannel(this.getPopupId, false);
        }
      }
      this.hidePopup();
    },
    toggleAddChannel() {
      this.addChannelOpen = !this.addChannelOpen
    },
    addChannels() {
      const channels = this.entity.channels.concat(this.addChannelIds.map(id => ({id_channel: id})))
      this.entityService.updateEntity(this.entity.id, {channels: channels})
          .then(() => {
            this.$emit('reloadEntity')
            this.addChannelIds = []
            this.addChannelOpen = false
          })
          .catch(function (error) {
            this.setErrorMessage(this._processDetailErrorMessage(error))
          }.bind(this))
    },
    deleteChannel(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'delete-channel')
      } else {
        const channels = this.entity.channels.filter(channel => channel.id_channel !== id)
        this.entityService.updateEntity(this.entity.id, { channels: channels })
            .then(() => {
              this.$emit('reloadEntity')
            })
            .catch(function (error) {
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    searchChannels(search, selectAll=false) {
      return this.channelService.searchChannelsByName({ search: search, select_all: selectAll })
    },
    changeSorting(newSort) {
      this.sort = newSort
      this.entity.channels = sortByKey(this.entity.channels, this.sort.column, this.sort.direction);
    },
    getActiveSort(column) {
      if (this.sort && this.sort.column === column) {
        return this.sort.direction
      } else {
        return false
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/channelGroup/ChannelsList.vue